import axios from 'axios'
import ToasterWrapper from '@/react/components/ToasterWrapper';
import { duration } from 'moment';
import _ from 'lodash';
const { toast } = ToasterWrapper

const initStaticPage = async ({ taxonomyDropdownRef, initROCategoryMultiLayer }) => {
	// this inits static page elements like dropdowns etc.
	taxonomyDropdownRef.current = await initROCategoryMultiLayer('#taxonomyDropdown')
}

const initTableHeaders = async ({
	API_URL,
	setHeaders,
	HEADER_NAMES,
	visibleColumns,
	period_map,
	editableColumns = [],
}) => {
	const { data } = await axios.get(`${API_URL}list/cat-sub-rec`, {
		headers: (window).HEADER_OBJ
	})

	// data contains the list of categories, subcategories, and record types. Lets extract them
	let categories = []
	let subcategories = []
	let recordTypes = []
	let periodMap = []

	categories = data.map(x => ({ text: x.name, value: x.id }))
	subcategories = data.reduce((acc, x) => {
		acc.push(...x.subcategories)
		return acc
	}, []).map(x => ({ text: x.name, value: x.id }))

	recordTypes = data.reduce((acc, x) => {
		acc.push(...x.subcategories.reduce((acc, x) => {
			acc.push(...x.recordTypes)
			return acc
		}, []))
		return acc
	}, []).map(x => ({ text: x.name, value: x.id }))

	periodMap = Object.entries(period_map).map(([key, value]) => ({ value: key, text: value }))

	const dataMapping = {
		'Category': categories,
		'Subcategory': subcategories,
		'Record Type': recordTypes,
		'Period': periodMap,
	}

	const result = HEADER_NAMES.map(x => {
		const obj = { heading: x }
		if (x === 'Period') {
			obj.isNullable = true
		} else {
			obj.isNullable = false
		}

		if (x !== 'Action' && x !== 'Jurisdiction') {
			obj.type = 'text'
		}

		if (x === 'Legal Reference link') {
			obj.type = 'link'
		}

		if (visibleColumns && visibleColumns.length > 0) {
			obj.isVisible = visibleColumns.includes(x)
		} else {
			obj.isVisible = true
		}

		if (dataMapping[x]) {
			obj.type = 'dropdown'
			if (dataMapping[x].length > 0) {
				obj.dropdownData = dataMapping[x]
			}

			if (x === 'Category' || x === 'Period') {
				obj.static = true
			}
		}

		return obj
	})
	if (setHeaders)
		setHeaders(result)
	else
		return result
}

const validateDataOnCellSave = ({ previousData, newData, column, cell, fromTimeline, tableRef, specific_retention_values, row }) => {

	if (_.isEqual(previousData, newData)) {
		if (fromTimeline) {
			toast((t) => {
				return <div className='flex flex-col gap-2 items-center'>
					<p>No changes detected while undoing/redoing, as</p>
					<b className='text-orange-600'>{previousData.text}</b> <span className='text-green-600'><b>is equal to</b></span>
					<b className='text-orange-600'>{newData.text}</b>
					<p>at column <b className='text-orange-600'>{column.heading}</b></p>
					<button className='btn btn-wide' onClick={() => toast.dismiss(t.id)}>
						Dismiss
					</button>
				</div>
			}, {
				duration: 15000,
				style: {
					maxWidth: '100%'
				}
			})
		}

		return
	}

	if (column.heading === 'Routing Number' && !(window).checkRoutingNumberValidity(newData.text, true)) {
		cell.updateData(previousData, false)
		toast.error('Please enter a valid routing number');
		return
	}

	const periodColumnIndex = tableRef.current.columns.findIndex((col) => col.heading === 'Period');
	const periodCell = tableRef.current.getCell(row.dataset.index, periodColumnIndex);

	if (column.heading === 'Retention') {
		if (!isNumber(newData.text) && !specific_retention_values.includes(newData.text)) {
			cell.updateData(previousData, false)
			toast.error('Invalid retention value')
			return 
		}

		if (specific_retention_values.includes(newData.text)) {
			setTimeout(() => {
				periodCell.updateData(null, false)
				periodCell.setActive(false)
				periodCell.setEditable(false)
			}, 100)
		} else {
			setTimeout(() => {
				periodCell.setActive(true)
				periodCell.setEditable(true)
			}, 100)
		}
	}


	return {
		previousData,
		newData
	}
}

const validateAndAddKeysToCellSavePayload = ({ payload, column, COL_TO_PAYLOAD_KEY_MAP, newData }) => {
	payload[COL_TO_PAYLOAD_KEY_MAP[column.heading]] = newData.value

	if (Object.keys(payload).length === 0) return false
	return true
}

const generateDependentDropdown = async ({ tableRef, cell, column, row }) => {
	if (column.heading !== 'Subcategory' && column.heading !== 'Record Type') return
	// get the dependent cell
	const targetHeading = column.heading === 'Subcategory' ? 'Category' : 'Subcategory'
	const prevColIndex = tableRef.current.columns.findIndex(x => x.heading === targetHeading)
	const previousColumnCell = row.getCell(prevColIndex)

	if (previousColumnCell.getData().value === '') return cell.setDropdownData([])

	const endpoint = previousColumnCell.dataset.header === 'Category'
		? 'list/subcategory-data?category='
		: 'list/record-type-data?subcategory=';

	const url = `${API_URL}/${endpoint}${previousColumnCell.getData().value}`;

	const dropdownData = await axios.get(url, { headers: window.HEADER_OBJ })

	if (dropdownData.status === 200) {
		cell.setDropdownData(dropdownData.data.data.map(x => ({ text: x.name, value: x.id })))
	}
}

function isNumber(str) {
	return /^\d+$/.test(str);
}

export {
	initStaticPage,
	initTableHeaders,
	validateDataOnCellSave,
	validateAndAddKeysToCellSavePayload,
	generateDependentDropdown,
	isNumber
}
